import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackCheckoutSessionStarted, trackDemoStarted } from '../utils/analytics';
import { buildStripeUrl } from '../utils/environment';
import { ASSET_VERSIONS, getVersionedAsset } from '../utils/constants';

const Hero = () => {
  const navigate = useNavigate();
  const phrases = [
    "your financial goals",
    "being debt free",
    "$100,000",
    "$1,000,000", 
    "$5,000,000",
    "$100,000,000",
    "financial freedom"
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const handlePrimaryClick = () => {
    trackCheckoutSessionStarted('header');
    
    const stripeUrl = buildStripeUrl();
    if (stripeUrl) {
      window.open(stripeUrl, '_blank');
    } else {
      console.error('Failed to build Stripe URL. Check environment configuration.');
    }
  };

  const handleDemoClick = () => {
    trackDemoStarted('header');
    navigate('/demo');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentPhraseIndex((prevIndex) => 
          prevIndex === phrases.length - 1 ? 0 : prevIndex + 1
        );
        setIsVisible(true);
      }, 400);
    }, 4000);

    return () => clearInterval(interval);
  }, [phrases.length]);

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <p className="hero-overline">PRIVACY-FIRST PERSONAL FINANCE</p>
          <h1>
            Chart your path to
            <br />
            <span 
              className={`rotating-text ${isVisible ? 'visible' : 'hidden'}`}
            >
              {phrases[currentPhraseIndex]}
            </span>
          </h1>
          <p className="hero-subtitle">
            Take control of your financial future with a private, offline app you own forever.
          </p>
          <div className="hero-buttons">
            <button 
              className="btn btn-primary"
              onClick={handlePrimaryClick}
            >
              50% OFF - Buy Today, Own Forever →
            </button>
            <button 
              className="btn btn-secondary"
              onClick={handleDemoClick}
            >
              Watch Demo Video
            </button>
          </div>
          <p className="hero-trust-statement">
            Secure. Private. No subscriptions. 7-day refund guarantee. Works offline on Windows and macOS.
          </p>
        </div>
        <div className="hero-visual">
          <div className="app-preview">
            <img 
              src={getVersionedAsset('/Solidly Finance App.png', ASSET_VERSIONS.HERO_IMAGE)}
              alt="Solidly Finance App Screenshot" 
              className="app-screenshot"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;